// extracted by mini-css-extract-plugin
export var cancelButton = "SupplierSelectModal-module--cancelButton--OlhBH";
export var container = "SupplierSelectModal-module--container--2c92s";
export var content = "SupplierSelectModal-module--content--Gam5H";
export var footer = "SupplierSelectModal-module--footer--LGph6";
export var header = "SupplierSelectModal-module--header--td+XH";